import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import TeacherProfileSetup from "@/pages/TeacherProfileSetup";
import FamilyProfileSetup from "@/pages/FamilyProfileSetup";
import TeacherSearch from "@/pages/TeacherSearch";
import TeacherDetail from "@/pages/TeacherDetail";
import Favorites from "@/pages/Favorites";
import Contact from "@/pages/Contact";
import TeacherOwnProfile from "@/pages/TeacherOwnProfile";
import AdminDashboard from "@/pages/AdminDashboard";
import FamilyProfile from "@/pages/FamilyProfile";
import Pricing from "@/pages/Pricing";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/giris/:role" element={<Login />} />
            <Route path="/kayit" element={<Signup />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/fiyatlandirma" element={<Pricing />} />

            <Route path="/ogretmen/kurulum" element={
              <ProtectedRoute role="teacher"><TeacherProfileSetup /></ProtectedRoute>
            } />
            <Route path="/ogretmen/profil" element={
              <ProtectedRoute role="teacher"><TeacherOwnProfile /></ProtectedRoute>
            } />

            <Route path="/aile/kurulum" element={
              <ProtectedRoute role="family"><FamilyProfileSetup /></ProtectedRoute>
            } />
            <Route path="/aile/profil" element={
              <ProtectedRoute role="family"><FamilyProfile /></ProtectedRoute>
            } />
            <Route path="/ara" element={
              <ProtectedRoute><TeacherSearch /></ProtectedRoute>
            } />
            <Route path="/ogretmen/:id" element={
              <ProtectedRoute><TeacherDetail /></ProtectedRoute>
            } />
            <Route path="/favorilerim" element={
              <ProtectedRoute role="family"><Favorites /></ProtectedRoute>
            } />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
